// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LEGACY_Markdown-wrapper_b24293e6"};